@@ -0,0 +1,69 @@
<template>
    <div class="max-w-2xl mx-auto pt-12 text-lg lg:text-xl">
        <div v-for="question in historyQuestions">
            <div class="bg-blue-700 border-b-4 border-blue-300 text-white px-4 py-3 rounded-md mb-2 max-w-lg">
                {{ question.message }}
            </div>
            <div class="flex justify-end">
                <div class="bg-yellow-400 border-b-4 border-yellow-500 text-blue-700 px-4 py-3 rounded-md mb-2 ml-auto items-end">
                    {{ getSelectedAnswer(question).label }}
                </div>
            </div>
        </div>
        <div  class="bg-blue-700 text-white border-b-4 border-blue-300  px-4 py-3 rounded-md mb-2 max-w-lg">
            {{ activeQuestion.message }}
        </div>
        <template v-if="activeQuestion.options">
            <button
                v-for="option in activeQuestion.options"
                @click="selectOption(activeQuestion, option)"
                class="bg-blue-200 px-4 py-3 text-white rounded-md mr-2 border-b-4 border-blue-400 focus:outline-none focus:bg-blue-300 hover:bg-blue-300 duration-100 mb-2"
            >{{ option.label}}
            </button>
        </template>
        <template v-if="activeQuestion.form">
            <div class="max-w-sm flex justify-end flex-wrap">

                <div class="bg-blue-200 px-4 py-3 w-full text-white rounded-md mr-2 border-b-4 border-blue-400 duration-100 mb-2">
                    <div class="mb-2">
                        <label for="company" class="text-sm block">Bedrijfsnaam:</label>
                        <input id="company" class="bg-transparent block w-full text-white placeholder-white" placeholder=""/>
                    </div>
                    <div class="mb-2">
                        <label for="name" class="text-sm block">Uw naam:</label>
                        <input id="name" class="bg-transparent block w-full text-white placeholder-white" placeholder=""/>
                    </div>
                    <div class="mb-2">
                        <label for="email" class="text-sm block">E-mailadres:</label>
                        <input id="email" class="bg-transparent block w-full text-white placeholder-white" placeholder=""/>
                    </div>
                    <div class="mb-2">
                        <label for="phone" class="text-sm block">Telefoon:</label>
                        <input id="phone" class="bg-transparent block w-full text-white placeholder-white" placeholder=""/>
                    </div>
                </div>
                <button @click="sendMessage"
                        class="bg-gray-300 px-4 py-3 text-gray-400 rounded-md mr-2 border-b-4 border-gray-400 focus:outline-none focus:bg-blue-300 hover:bg-blue-300 duration-100 mb-2">versturen
                </button>


            </div>
        </template>

    </div>
</template>

<script>
import ConversationQuestions from './ConversationQuestions.json'

export default {
    created: function() {
        this.questions = ConversationQuestions;
        this.setActiveQuestion(0);
    },
    methods: {
        getSelectedAnswer(question) {
            return question.options.find(option => {
                return option.selected === true;
            });
        },

        selectOption(question, selectedOption) {
            selectedOption.selected = true;
            this.setActiveQuestion(selectedOption.next_step_id);
        },
        setActiveQuestion(questionId) {
            if (this.activeQuestion) {
                this.historyQuestions.push(this.activeQuestion);
            }

            this.activeQuestion = this.questions.find(question => {
                return question.id === questionId;
            });
        }
    },
    data: function() {
        return {
            activeQuestion: null,
            historyQuestions: [],
            questions: []
        };
    },
    props: {
        msg: String
    }
};
</script>
